import { Link, useSearchParams } from 'react-router'

/*
 * Statuspagina na de betaling (FR-10, FR-13a).
 *
 * Mollie stuurt hierheen terug met ?ref={dossiernummer}. Deze pagina vraagt
 * daarmee géén status op, en dat is een besluit, geen tekortkoming: ADR-0006
 * scheidt het dossiernummer van het betaaltoken juist omdat het nummer in mails
 * en telefoongesprekken circuleert. Zou het hier een status opleveren, dan kon
 * iedereen GPK-2026-0001 tot 9999 aflopen en zien wie er betaald heeft.
 *
 * Gevolg: deze pagina weet niet of het gelukt is. De tekst dekt daarom beide
 * afloopen eerlijk af, in plaats van te doen alsof. Wie wél de status wil zien,
 * of opnieuw wil betalen, gebruikt de betaallink uit de ontvangstbevestiging —
 * die draagt het token en komt uit op /betaal/{token} (FR-11).
 *
 * De echte bevestiging is de e-mail. Die komt er ook als deze pagina gemist
 * wordt doordat iemand zijn browser dichtklapt.
 */
export default function Bedankt() {
  const [zoekparameters] = useSearchParams()
  const kenmerk = zoekparameters.get('ref')

  return (
    <section className="section" style={{ paddingTop: 'clamp(36px,5vw,56px)' }}>
      <div className="wrap">
        <div className="flow">
          <div className="flowcard">
            <h1>Bedankt voor uw aanvraag</h1>

            {kenmerk && (
              <p className="lede">
                Uw kenmerk is <strong>{kenmerk}</strong>. Bewaar dit nummer; wij
                gebruiken het in onze e-mails en aan de telefoon.
              </p>
            )}

            <p className="lede" style={{ marginTop: '14px' }}>
              U ontvangt van ons een e-mail zodra uw betaling verwerkt is.
              Daarna nemen wij contact met u op om een afspraakmoment te
              plannen.
            </p>

            <div className="infoband" style={{ marginTop: '26px' }}>
              <h2>Is het betalen niet gelukt?</h2>
              <p>
                Dat is geen probleem: uw gegevens zijn bewaard en u hoeft het
                formulier niet opnieuw in te vullen. In de e-mail die u van ons
                heeft gekregen staat een betaallink die geldig blijft. Daarmee
                rondt u de betaling alsnog af.
              </p>
              <p className="ext">
                Geen e-mail ontvangen? Kijk ook in uw map met ongewenste post,
                of <Link to="/contact">neem contact met ons op</Link>.
              </p>
            </div>

            <div style={{ marginTop: '26px' }}>
              <Link to="/" className="btn btn--ghost">
                Terug naar de homepage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
